import type { Paso, Plan } from '../types/content'

export const plan: Plan = {
  titulo: 'Mega Pack Manicuría Lista Completo',
  precioRegular: '$137 USD',
  precioHoy: '$17 USD',
  cta: 'Obtener el acceso AHORA',
  incluye: [
    '6 tomos completos',
    '5 bonos estratégicos',
    'Más de 300 recursos listos para usar',
    'Acceso inmediato en PDF editable',
    'Descargable desde cualquier país de LATAM',
    'Pago único sin suscripción',
    'Conversión automática a tu moneda local',
    'Garantía de 7 días',
  ],
}

export const pasos: Paso[] = [
  {
    icono: '🛒',
    numero: '01',
    titulo: 'Hacés el pago',
    descripcion:
      'Ingresás tu método de pago. La plataforma detecta tu país y convierte automáticamente el precio a tu moneda local. Podés simular el precio antes de confirmar.',
  },
  {
    icono: '📥',
    numero: '02',
    titulo: 'Descargás al instante',
    descripcion:
      'Recibís acceso inmediato a los 11 archivos PDF. Sin esperar. Sin aplicaciones. Sin suscripción. Desde cualquier dispositivo.',
  },
  {
    icono: '💅',
    numero: '03',
    titulo: 'Transformás tu trabajo',
    descripcion:
      'Empezás a usar el sistema con tu próxima clienta. Con estructura, precios claros y seguridad profesional desde el primer día.',
  },
]
